import { useLayout } from '@/layout/LayoutProvider';
import OldAlert, { Props } from '@storeblocks/alert';
import { Alert as RebrandedAlert } from '@storeblocks/rebrand/alert';

export const Alert = (props: Props) => {
  const { isRebrand } = useLayout();

  return isRebrand ? <RebrandedAlert {...props} /> : <OldAlert {...props} />;
};
